import { render, staticRenderFns } from "./ViberBrandNameList.vue?vue&type=template&id=17fcd52e"
import script from "./ViberBrandNameList.vue?vue&type=script&lang=js"
export * from "./ViberBrandNameList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports